import * as Yup from "yup";

import { accountIdValidation } from "../../utils/yupValidation";
import { AccountLookupFormValues } from "./AccountLookup";

const accountLookupSchema: Yup.SchemaOf<AccountLookupFormValues> =
  Yup.object().shape({
    accountId: accountIdValidation().required("Required").default(""),
  });

export default accountLookupSchema;
